import { usePageMetadata } from '@/hooks/usePageMetadata'

/**
 * Renders nothing; applies page title and meta description for the current route.
 * Mount inside a route branch (e.g. LoginPage or DashboardLayout).
 */
export function PageMetadata(): null {
  usePageMetadata()
  return null
}

PageMetadata.displayName = 'PageMetadata'
